module.exports = __webpack_public_path__ + "static/media/6_r_kolonka_88.44_38.52.b9e6f7f4.png";